export default __webpack_public_path__ + "static/media/landscape6.5e7e8751.JPEG";